import _ from "lodash";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { useStoreActions, useStoreState } from "../../models/RootStore";
import AccountManagement from "../AccountManagement/AccountManagement";
import CustomerManagement from "../CustomerManagment/CustomerManagement";
import DeviceManagement from "../DeviceManagment/DeviceManagement";
import DevicePackageManagement from "../DevicePackageManagement/DevicePackageManagement";
import DirectDevices from "../DirectDevices/DeviceManagement";
import Login from "../Login/Login";
import NoAccessScreen from "../NoAccess/NoAccessScreen";
import SiteDetails from "../SiteManagement/SiteDetails";
import EditAccount from "../AccountManagement/EditAccount";
import SiteManagement from "../SiteManagement/SiteManagement";
import TriggerManagment from "../TriggerManagement/TriggerManagment";
import UserMgmtNew from "../UserManagementNew/UserManagementNew";
import Authenticated from "./Authenticated";
import { ThemeProvider, createTheme } from "@mui/material/styles";
// Non 'JS Styles' CSS imports.
import { ErrorStoreMessage } from "../../components/ErrorStoreMessage";
import Loading from "../../components/Loading/Loading";
import AdminUsersList from "../AdminUserManagement/AdminUsersList";
import DebugDevices from "../DebugDevices/DebugDevices";
import VirtualDevices from "../VirtualDevices/VirtualDevices";
import BlockedDevices from "../BlockedDevices/BlockedDevices";
import NGDevices from "../NGDevices/NGDevices";
import DeviceManager from "../DeviceManagment/EditDevice";
import EditCustomer from "../EditCustomer/EditCustomer";
import Subscriptions from "../Subscriptions/Subscriptions";
import SubscriptionsCustomers from "../Subscriptions/SubscriptionsCustomers";
import SubscriptionsCustomerSites from "../Subscriptions/SubscriptionsCustomerSites";
import SubscriptionsSite from "../Subscriptions/SubscriptionsSite";
import SupportView from "../Support/SupportView";
import { StyledEngineProvider } from '@mui/material/styles';
import DeviceMigration from "../DeviceMigration/DeviceMigration";
import NewDeviceTests from "../NewDeviceTests/NewDeviceTests";
import ServiceParams from "../ServiceParams/ServiceParams";
import ServiceParamsEnums from "../ServiceParamsEnums/ServiceParamsEnums";
import AdminAudits from "../AdminAudits/AdminAudits";
import Dashboard from "../Dashboard/Dashboard";
import DirectUsers from "../DirectUsers/DirectUsers"
import AdvancedSearch from "../AdvancedSearch/AdvancedSearch";
import DeviceFamily from "../DeviceFamily/DeviceFamily";
import DeviceRecord from "../DeviceRecord/DeviceRecord";
import Availability from "../Availability/Availability"
import DierctTests from "../DirectTests/DirectTests";
import Customers from "../Customers/Customers";
import Monitoring from "../MonitoringScreen";
import DeviceHealth from "../DeviceHealth/DeviceHealth";
import Firmware from "../Firmware/Firmware";
import DaikinConsistency from "../DaikinConsistency/DaikinConsistency";
import DeviceSync from "../DeviceSync/DeviceSync";
import DeviceImport from "../DeviceImport/DeviceImport";
import DeviceAudits from "../EdgeAudits/DeviceAudits";
import DeviceTelemetryRecoveryDetail from "../EdgeAudits/DeviceTelemetryRecoveryDetail";
import ModbusTemplateManagement from "../ModbusTemplateManagement/ModbusTemplateManagement";
import PushTokens from "../PushTokens";
import Queues from "../Queues/Queues";

const getAllowedRoute = (mySupportedPages: any) => {

  const showAllPages = mySupportedPages === "all";
  if (showAllPages || mySupportedPages["dashboard"]) {
    return "/dashboard";
  }
  if (showAllPages || mySupportedPages["customers"]) {
    return "/customers";
  }
  if (showAllPages || mySupportedPages["sites"]) {
    return "/sites";
  }
  if (showAllPages || mySupportedPages["devices"]) {
    return "/devices";
  }
  if (showAllPages || mySupportedPages["device-tests"]) {
    return "/device-tests";
  }
  if (mySupportedPages["device-packages"]) { //globalAdmins shouldn't see this page, thats why we don't have showAll here
    return "/device-packages";
  }
  if (showAllPages || mySupportedPages["users"]) {
    return "/users";
  }
  if (showAllPages || mySupportedPages["users2"]) {
    return "/users2";
  }
  if (showAllPages || mySupportedPages["availability"]) {
    return "/availability";
  }
  if (showAllPages || mySupportedPages["admin-users"]) {
    return "/admin-users";
  }
  if (showAllPages || mySupportedPages["support"]) {
    return "/SupportView";
  }
  if (showAllPages || mySupportedPages["ng-devices"]) {
    return "/ng-devices";
  }

  if (showAllPages || mySupportedPages["subscriptions"]) {
    return "/subscriptions";
  }
  if (showAllPages || mySupportedPages["subscriptions-customers"]) {
    return "/subscriptions-customers";
  }
  if (showAllPages || mySupportedPages["subscriptions-customer-sites"]) {
    return "/subscriptions-customer-sites";
  }
  if (showAllPages || mySupportedPages["subscriptions-site"]) {
    return "/subscriptions-site";
  }
  if (showAllPages || mySupportedPages["accounts"]) {
    return "/accounts";
  }
  if (showAllPages || mySupportedPages["device-health"]) {
    return "/device-health";
  }
  return "/";
};

export default function App() {
  const themeFile = useStoreState((state) => state.theme);
  const prepareTheme = useStoreActions((actions) => actions.prepareTheme);
  const { mySupportedPages = "all", userFlags = {} } = useStoreState((s) => s.users);
  const showAllPages = mySupportedPages === "all";
  const enableModbusLibraryTemplates = userFlags.enableModbusLibraryTemplates !== false;

  const logout = useStoreActions((actions) => actions.users.logout);
  const checkLoggedin = useStoreActions(
    (actions) => actions.users.checkLoggedin
  );
  const getUserTree = useStoreActions((action) => action.getUserTree);
  const setLoggedIn = useStoreActions((action) => action.setLoggedIn);
  const isLoggedIn = useStoreState((s) => s.isLoggedIn);
  const { dataState } = useStoreState((s) => s.users);
  const getserviceTypes = useStoreActions((action) => action.getServiceTypes);
  const getUserFlags = useStoreActions((action) => action.users.getUserFlags);
  const messageObj = useStoreState((s) => s.errorMessage.message);
  const customers = useStoreState((s) => s.customers.customersBasicList);

  const initialize = async () => {
    if (isLoggedIn) {
      try {
        await getUserTree()
        await getserviceTypes()
        await getUserFlags()
      } catch (error) {
        setLoggedIn(false);
        logout();
      }
    }
  };

  useEffect(() => {
    initialize();
  }, [isLoggedIn]);

  // useEffect(() => {
  //   getserviceTypes();
  // }, [getserviceTypes]);

  useEffect(() => {
    checkLoggedin();
  }, [checkLoggedin]);

  useEffect(() => {
    if (!themeFile) {
      prepareTheme();
    }
  }, [themeFile]);

  if (!themeFile) {
    return <></>;
  }

  if (dataState === "loading") {
    return <Loading />;
  }

  if (isLoggedIn && (window?.location?.href?.includes("-diag") && _.isEmpty(customers))) {
    return <Loading />;
  }

  const theme = createTheme(themeFile);

  return (
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        <div className="App">
          <Router>
            <Switch>
              <Route exact={true} path="/" component={Login} />
              <Route exact={true} path="/no-access" component={NoAccessScreen} />
              <Authenticated exact path="/audits" component={AdminAudits} />
              {(showAllPages || mySupportedPages["sites"]) && <Authenticated exact path="/sites" component={SiteManagement} />}
              {(showAllPages || mySupportedPages["device-family"]) && <Authenticated exact path="/device-family" component={DeviceFamily} />}
              {(showAllPages || mySupportedPages["device-records"]) && <Authenticated exact path="/device-records" component={DeviceRecord} />}
              {showAllPages && <Authenticated exact path="/trigger-management" component={TriggerManagment} />}
              {(showAllPages || mySupportedPages["direct-devices"]) && <Authenticated exact path="/direct-devices" component={DirectDevices} />}
              {(showAllPages || mySupportedPages["device-tests"]) && <Authenticated exact path="/direct-tests" component={DierctTests} />}
              {(showAllPages || mySupportedPages["direct-users"]) && <Authenticated exact path="/direct-users" component={DirectUsers} />}
              {<Authenticated exact path="/availability" component={Availability} />}
              {(showAllPages || mySupportedPages["users2"]) && <Authenticated exact path="/users2" component={UserMgmtNew} />}
              {(showAllPages || mySupportedPages["admin-users"]) && <Authenticated exact path="/admin-users" component={AdminUsersList} />}
              {(showAllPages || mySupportedPages["debug-devices"]) && <Authenticated exact path="/debug-devices" component={DebugDevices} />}
              {(showAllPages || mySupportedPages["virtual-devices"]) && <Authenticated exact path="/virtual-devices" component={VirtualDevices} />}
              {(showAllPages || mySupportedPages["blocked-devices"]) && <Authenticated exact path="/blocked-devices" component={BlockedDevices} />}
              {(showAllPages || mySupportedPages["ng-devices"]) && <Authenticated exact path="/ng-devices" component={NGDevices} />}
              {(showAllPages || mySupportedPages["customers"]) && <Authenticated exact path="/customers/new" component={EditCustomer} />}
              {(showAllPages || mySupportedPages["customers"]) && <Authenticated exact path="/customers/:customerId" component={EditCustomer} />}
              {(showAllPages || mySupportedPages["sites"]) && <Authenticated exact path="/customers/:customerId/sites" component={SiteManagement} />}
              {/* {(showAllPages || mySupportedPages["direct-sites"]) && <Authenticated exact path="/direct-sites" component={DirectSites} />} */}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/customers/:customerId/devices" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["device-tests"]) && <Authenticated exact path="/device-tests" component={NewDeviceTests} />}
              {/* {(showAllPages || mySupportedPages["admin-audits"]) && <Authenticated exact path="/admin-audits" component={AdminAudits} />} */}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/customers/:customerId/devices/disconnected" component={DeviceManagement} disconnected={true} />}
              {(showAllPages || mySupportedPages["customers"]) && <Authenticated exact path="/customers" component={Customers} />}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/devices" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/devices/registered" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/devices/disconnected" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/devices/disconnected/registered" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/devices/connected/registered" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/devices/connected" component={DeviceManagement} />}
              {false && <Authenticated exact path="/device-packages" component={DevicePackageManagement} />}
              {/* {(showAllPages || mySupportedPages["device-packages"]) && <Authenticated exact path="/device-packages" component={DevicePackageManagement} />} */}
              {/* Always register so deep links survive session hydration (pages gate would drop the match). */}
              <Authenticated allowAfterRefresh exact path="/devices/:deviceId/sync" component={DeviceSync} />
              <Authenticated allowAfterRefresh exact path="/devices/:deviceId/audit" component={DeviceAudits} />
              <Authenticated allowAfterRefresh exact path="/devices/:deviceId/connections" component={DeviceAudits} />
              <Authenticated allowAfterRefresh exact path="/devices/:deviceId/telemetry-recovery" component={DeviceAudits} />
              <Authenticated allowAfterRefresh exact path="/devices/:deviceId/telemetry-recovery/:auditId" component={DeviceTelemetryRecoveryDetail} />
              {showAllPages && <Authenticated exact path="/devices/import" component={DeviceImport} />}
              <Authenticated allowAfterRefresh exact path="/devices/:deviceId" component={DeviceManager} />
              {(showAllPages || mySupportedPages["devices"]) && <Authenticated exact path="/site/:siteId/devices" component={DeviceManagement} />}
              {(showAllPages || mySupportedPages["service-parameters"]) && <Authenticated exact path="/service-parameters" component={ServiceParams} />}
              {(showAllPages || mySupportedPages["service-parameters-enums"]) && <Authenticated exact path="/service-parameters-enums" component={ServiceParamsEnums} />}
              {(showAllPages || mySupportedPages["firmware"]) && <Authenticated exact path="/firmware" component={Firmware} />}
              {(showAllPages || mySupportedPages["sites"]) && <Authenticated exact path="/site/:siteId" component={SiteDetails} />}
              {(showAllPages || mySupportedPages["support"]) && <Authenticated exact path="/SupportView" component={SupportView} />}
              {(showAllPages || mySupportedPages["accounts"]) && <Authenticated exact path="/accounts" component={AccountManagement} />}
              {(showAllPages || mySupportedPages["accounts"]) && <Authenticated exact path="/account/:accountId" component={EditAccount} />}
              {(showAllPages || mySupportedPages["subscriptions"]) && <Authenticated exact path="/subscriptions" component={Subscriptions} />}
              {(showAllPages || mySupportedPages["subscriptions"]) && <Authenticated exact path="/customers/:customerId/subscriptions" component={Subscriptions} />}
              {(showAllPages || mySupportedPages["subscriptions-customers"]) && <Authenticated exact path="/subscriptions-customers" component={SubscriptionsCustomers} />}
              {(showAllPages || mySupportedPages["subscriptions-customer-sites"]) && <Authenticated exact path="/subscriptions-customer-sites" component={SubscriptionsCustomerSites} />}
              {(showAllPages || mySupportedPages["subscriptions-site"]) && <Authenticated exact path="/subscriptions-site" component={SubscriptionsSite} />}
              {(showAllPages || mySupportedPages["device-migration"]) && <Authenticated exact path="/device-migration" component={DeviceMigration} />}
              {(showAllPages || mySupportedPages["dashboard"]) && <Authenticated exact path="/dashboard" component={Dashboard} />}
              {(showAllPages || mySupportedPages["search"]) && <Authenticated exact path="/search" component={AdvancedSearch} />}
              {(showAllPages || mySupportedPages["monitoring"]) && <Authenticated exact path="/monitoring" component={Monitoring} />}
              {(showAllPages || mySupportedPages["modbus-template-management"]) && enableModbusLibraryTemplates && <Authenticated exact path="/modbus-template-management" component={ModbusTemplateManagement} />}
              {/* Deliberately ungated, matching the menu item in components/Menu/Menu.tsx:
                  no permissions are defined for this page yet. When product asks for it to
                  be restricted, add the (showAllPages || mySupportedPages["device-health"])
                  guard in both places. */}
              <Authenticated exact path="/device-health" component={DeviceHealth} />
              <Authenticated exact path="/dk-consistency" component={DaikinConsistency} />
              {/* Deliberately ungated, same rationale as /device-health above: no
                  permissions are defined for this page yet. When product asks for it to
                  be restricted, add the (showAllPages || mySupportedPages["push-tokens"])
                  guard here and to the matching menu item in components/Menu/Menu.tsx. */}
              <Authenticated exact path="/push-tokens" component={PushTokens} />
              {/* Hidden: no menu entry, reachable by URL only. Global admins only. */}
              {showAllPages && <Authenticated exact path="/queues" component={Queues} />}
              <Redirect to={showAllPages || mySupportedPages["dashboard"] ? "/" : getAllowedRoute(mySupportedPages)} />
            </Switch >
          </Router >
          {messageObj.message && (<ErrorStoreMessage message={messageObj} />)}
        </div >
      </StyledEngineProvider >
    </ThemeProvider >
  );
}
